export default {
  message: {
    hello: 'こんにちは',
    welcome: '私たちのウェブサイトへようこそ',
    switchLanguage: '言語切替',
    home: 'ホーム',
    about: '会社概要',
    contact: 'お問い合わせ',
    news: 'ニュース',
    games: 'ゲーム特徴',
    download: 'ダウンロード',
    community: 'コミュニティ',
    footer: 'すべての権利予約',
    privacyPolicy: 'プライバシーポリシー',
    accountDeletion: 'アカウント削除',
    lastUpdated: '最終更新',
    // アカウント削除
    deletionInApp: 'アプリ内からアカウント削除を申請',
    recommended: '推奨',
    deletionInAppDesc: 'ゲームアプリ内から直接アカウント削除を申請できます。これが最速の方法で、システムが自動的にリクエストを処理します。以下の手順で操作してください：',
    deletionByEmail: 'メールでアカウント削除を申請',
    ifCannotAccessApp: 'アプリにアクセスできない場合',
    deletionByEmailDesc: 'アプリにログインできない場合は、メール送信でアカウント削除を申請できます。以下の手順で操作してください：',
    deletionEmailStep1: '登録時のメールアドレスからサポートメールアドレスにメールを送信',
    deletionEmailStep2: 'メールの件名に「アカウント削除申請」と記載',
    deletionEmailStep3: 'メール本文にユーザーIDまたは登録メールアドレスを記載',
    deletionEmailStep4: '本人確認情報（購入履歴のスクリーンショットなど）を添付して、身元確認を行えるようにする',
    dataRetention: 'データ削除と保持ポリシー',
    dataRetentionDesc: 'アカウント削除リクエストを提出した後、以下のポリシーに従ってデータを処理します：',
    dataRetentionDelete: 'アカウント情報、ゲームキャラクターデータ、フレンドリストなどは30営業日以内に削除されます',
    dataRetentionKeep: '一部の取引記録は、適用法令の要件に基づき一定期間保持される場合があります',
    dataRetentionLegal: '法的義務の遵守、紛争の解決、契約の執行のために保持が必要なデータは安全に保管されます',
    dataRetentionAnon: '匿名化されたデータ（個人を識別できないもの）は統計分析目的で保持される場合があります',
    importantNotice: '重要なお知らせ',
    actionRequired: '追加の手順が必要です',
    importantNoticeDesc: 'アカウント削除を申請する前に、以下の点にご注意ください：',
    noticeIrreversible: 'アカウント削除は取り消せません。すべてのゲームデータが永久に失われ、復元できません',
    noticeProgress: '処理中のゲーム注文、未受領の報酬などは削除後に失効します',
    noticeSubscription: '有効なサブスクリプションがある場合は、アカウント削除前にキャンセルしてください',
    noticeRecovery: '削除後、同じアカウントを再登録または復元することはできません',
    noticeSync: '関連付けられたサードパーティアカウント（Google、Apple IDなど）の連携も同時に解除されます',
    deletionContact: 'お問い合わせ',
    deletionContactDesc: 'アカウント削除の過程で問題が発生した場合は、以下の方法でお問い合わせください：',
    replaceImageHint: '操作スクリーンショットに差し替えてください',
    // フッターリンク
    footerPrivacyPolicy: 'プライバシーポリシー',
    footerAccountDeletion: 'アカウント削除'
  }
}